import { ApiModelGoToDashboard }  from '@widesk-ui/mixins/ApiModelGoToDashboard';
import { ApiModelLocalizedLabel } from '@widesk-core/mixins/ApiModelLocalizedLabel';
import { ApiModelRenderName }     from '@widesk-ui/mixins/ApiModelRenderName';
import ApiModel                   from '@widesk-core/models/ApiModel';

export default ApiModelGoToDashboard(ApiModelLocalizedLabel(ApiModelRenderName(ApiModel)));